<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Tambah Pesanan</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Ubah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Hapus</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Ekspor
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Campaign</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>

          <!-- <b-input-group>
            <b-input-group-prepend>
              <label>Kota Layanan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              @change="tblData.kota_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <span class="pl-2 pt-2 pr-1">Jurusan</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.jurusan_name"
              @keyup.13.native="lkuKoranJurusanShow=true" 
              @change="tblData.jurusan_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group> -->
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kiriman_name" @change="tblData.kiriman_code=''" placeholder="Jenis Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <span class="pl-2 pt-2 pr-1">Kota Layanan</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              @change="tblData.kota_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

        </b-col>
        <b-col lg="5">
         <b-input-group>
            <b-input-group-prepend>
              <label>Nama Penerima</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
         <b-input-group>
            <b-input-group-prepend>
              <label>Target Penerima</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.linetype"
              :options="linetype"
              class="mb-1"
              :plain="true"
            >
              <template v-slot:first>
                <option :value="null" disabled>-- Pilih Target Campaign --</option>
              </template>
            </b-form-select>
            <b-input-group-append class="ml-2">
              <b-button class="btn btn-success ml-3 mr-1" size="sm" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary" size="sm"  @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter
              </b-button>
            </b-input-group-append>

          </b-input-group>                    
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:thead-top="data">
          <b-tr>
            <!-- <b-th >                  
              <span class="sr-only">action</span>
            </b-th> -->
            <b-th colspan="6">
              <span class="sr-only">alamat, phone, kota, jenis, ae</span>
            </b-th>
            <b-th variant="warning" colspan="7" class="text-center">POLA KIRIMAN GRATIS</b-th>
          </b-tr>
        </template>

        <template v-slot:cell(CustName)="data">{{data.item.CustCode}} | {{data.item.CustName}}</template>

        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
            <b-input-group-prepend class="mb-0">
              <span class="p-2">Limit per page</span>
            </b-input-group-prepend>
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:90px !important;"
            />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true"> 
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="List Kota" :centered="true"> 
      <lku-kota @click="onSelectKota"></lku-kota>
    </b-modal>
    <b-modal v-model="lkuKoranJurusanShow" size="lg" :hide-footer="true" title="List Jurusan" :centered="true">
      <lku-jurusan @click="onSelectJurusan"></lku-jurusan>
    </b-modal>

    <b-modal v-model="lkuKoranKirimanCodeShow" size="lg" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman" crudfilter="gratis=1"></lku-koranjeniskiriman>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import crud from "../../apis/crud";
import koran_pesanan from "../../apis/koran_pesanan_gratis";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuKota from "../lookup/lkuKoranKota";
import lkuJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";

import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuKota, lkuJurusan, lkuKoranjeniskiriman },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: null,
      terpilih: { customer_id: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: null,
        sortDesc: false,
        koran: "1",
        linetype: null,
        kota_id: null,
        jurusan_id: null,
        tgl1: null,
        tgl2: null
      },
      linetype: [],
      korankota: [],
      koranJrsList: [],
      tgl1: null,
      tgl2: null,
      lkuKoranCustShow: false,
      lkuKoranKotaShow: false,
      lkuKoranKirimanCodeShow: false,
      lkuKoranJurusanShow: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "campaignname",
          label: "Uraian Gratisan/Promo",
          sortable: true
        },
        {
          key: "periode",
          label: "Periode Promo",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "linename",
          label: "Target",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Penerima",
          sortable: true
        },
        {
          key: "kota_name",
          label: "Kota Layanan",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "seninEcer",
          label: "sen",
          variant: "warning",
          thStyle: "width:40px",
        },
        {
          key: "selasaEcer",
          label: "sel",
          thStyle: "width:40px",
        },
        {
          key: "rabuEcer",
          label: "rab",
          thStyle: "width:40px",
        },
        {
          key: "kamisEcer",
          label: "kam",
          thStyle: "width:40px",
        },
        {
          key: "jumatEcer",
          label: "jum",
          thStyle: "width:40px",
        },
        {
          key: "sabtuEcer",
          label: "sab",
          thStyle: "width:40px",
        },
        {
          key: "mingguEcer",
          label: "ming",
          thStyle: "width:40px",
          variant: "warning",
        },
      ];
      return fields;
    }
  },
  watch: {
    tgl1(val) {
      if (val !== null) this.tblData.tgl1 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl1 = null;
    },
    tgl2(val) {
      if (val !== null) this.tblData.tgl2 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl2 = null;
    }
  },
  created: async function() {
    const [a, b, c] = await Promise.all([
      crud.list({ tablename: "korancampaignlinetype" }),
      crud.list({ tablename: "vwkorankota", limit: 1000 }),
      crud.list({ tablename: "vwkoranjurusan", limit: 1000 })
    ]);

    this.linetype = a.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.linetype,
        text: `${el.linename}`
      });
      return newArr;
    }, []);

    this.korankota = b.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.kota_id,
        text: `${el.kota_id} | ${el.kota_name}`
      });
      return newArr;
    }, []);

    this.koranJrsList = c;
    this.koranjurusan = c.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.jurusan_id,
        text: `${el.jurusan_code} | ${el.jurusan_name}`
      });
      return newArr;
    }, []);
  },
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectKota: function(_selected) {
      this.tblData.kota_id = _selected.kota_id;
      this.tblData.kota_name = _selected.kota_name;
      this.lkuKoranKotaShow = false;
    },
    onSelectJurusan: function(_selected) {
      this.tblData.jurusan_id = _selected.jurusan_id;
      this.tblData.jurusan_name = _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },

    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    // data: async function(ctx) {
    //   try {
    //     this.isLoading = true;
    //     this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //     const list = await koran_pesanan.list(this.tblData);
    //     list.forEach((element, idx) => {
    //       list[idx].startdate = element.startdate
    //         ? moment(element.startdate).format("YYYY-MM-DD")
    //         : "";

    //       list[idx].enddate = element.enddate
    //         ? moment(element.enddate).format("YYYY-MM-DD")
    //         : "";
    //     });
    //     this.isLoading = false;
    //     return list;
    //   } catch (error) {
    //     console.log("error", error);
    //     this.Loading = false;
    //   }
    // },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.pesanangratis) {
            this.tblData[key] = filter.pesanangratis[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.pesanangratis.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.pesanangratis;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_pesanan.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_pesanan.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    

    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.tblData.linetype = null;
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.kota_id = null;
      this.tblData.kota_name = null;
      this.tblData.jurusan_id = null;
      this.tblData.jurusan_name = null;
      this.tblData.kiriman_code = "";
      this.tblData.kiriman_name = "";

      this.refresh();
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','tgl1', 'tgl2', 'kota_id', 'kota_name', 'linetype', 'jurusan_id', 'jurusan_name', 'customer_id', 'CustName','kiriman_code','kiriman_name'];
      let filtered = false;
      const pesanangratis={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              pesanangratis[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          pesanangratis.page=this.tblData.page;
          pesanangratis.limit=this.tblData.limit;
          pesanangratis.sortBy=this.tblData.sortBy;
          pesanangratis.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.pesanangratis=pesanangratis;
          this.$store.commit("filter", filter);
      }
    },      

    add: function() {
      this.saveFilter();
      router.push({ name: "koran.pesanancampaignfrm" });
    },
    edit: function() {
      if (this.terpilih.tablekey) {
      this.saveFilter();
        router.push({
          name: "koran.pesanancampaignfrm",
          params: {
            tablekey: this.terpilih.tablekey
          }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.tablekey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await koran_pesanan.remove(this.terpilih);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.terpilih.customer_id == record.customer_id) {
        this.edit();
      } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_pesanan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    }
  }
};
</script>